import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { PrivateInput } from '../../Form/PrivateInput';

var Input = function Input(_ref) {
  var disabled = _ref.disabled,
      errors = _ref.errors,
      handleBlur = _ref.handleBlur,
      handleChange = _ref.handleChange,
      loading = _ref.loading,
      name = _ref.name,
      values = _ref.values,
      props = _objectWithoutProperties(_ref, ["disabled", "errors", "handleBlur", "handleChange", "loading", "name", "values"]);

  return /*#__PURE__*/React.createElement(PrivateInput, _extends({}, props, {
    disabled: loading || disabled,
    error: errors[name],
    errorText: errors[name] || 'This field is required',
    id: name,
    name: name,
    onBlur: handleBlur,
    onChange: handleChange,
    type: "password",
    value: values[name]
  }));
};

export { Input };